<template>
  <footer class="footer">
    <div class="footer__left">
      <a
        href="https://docs.google.com/document/d/195f4kNkZsc2OEY0SjGA2QTfQDL8SJagDKtKmMpVCXBg"
        class="footer__link"
        target="_blank"
      >
        Руководство пользователя
      </a>
    </div>
    <div class="footer__right">
      <span class="footer__link" @click="openChangeLogs">История изменений</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterPart',
  emits: ['open-dialog'],
  methods: {
    openChangeLogs() {
      this.$emit('open-dialog');
    },
  },
};
</script>

<style scoped>
.footer {
  height: 32px;
  padding: 5px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #455364;
}

.footer__link {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
</style>
